import Loadable from 'utils/Loadable';
export default Loadable(function () { return import('./MainContainer'); });
